import { assoc, always, compose, map, path, prop } from 'ramda';

import { URL_STATUS } from 'constants/regexp';
import { history } from 'store/browserHistory';

export const setFilter = (filter, defaultFilters, defaultStatus = 'all') => {
    if (filter === defaultStatus) return defaultFilters;
    return compose(assoc(filter, 1), map(always(0)))(defaultFilters);
};

export const getStatusPayload = state => ({
    status: path(['match', 'params', 'status'], state)
});

export const getStatus = () => compose(
    prop('status'),
    pathname => URL_STATUS.execGroups(pathname),
)(history.location.pathname);
